import { platform } from '../platform';
export default platform(
  () => import('./web/ErrorPage'),
  () => import('./mobile/ErrorPage')
);
